"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = validateFormat;

var _message = require("./message");

var _validator = require("./validator");

var _dig = require("./dig");

function validateFormat(v, fields, options) {
  var _ref = options || {},
      withFormat = _ref.withFormat,
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? '{key} is invalid' : _ref$message,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'format' : _ref$type;

  v = Object.assign({}, v);
  var messages = [fields].flat().filter(function (field) {
    return invalid((0, _dig.dig)(v.data, field), withFormat);
  }).map(function (field) {
    return (0, _message.addMessage)(field, message, type);
  });
  return (0, _validator.updateValidator)(v, messages);
}

function invalid(data, format) {
  return !format.test(data);
}